import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Kids from "./container/Kids/Kids";
import TvShow from "./container/TvShows/TvShow";
import Movies from "./container/Movies/Movies";
import Home from "./container/Home/Home";

import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import MovieDetail from "./container/Detail/MovieDetail";
import DetailsFile from "./component/DetailsFile";

const router = createBrowserRouter(
  createRoutesFromElements(

    <Route path="/" element={<App />}>
      <Route index path='' element={<Home />} />
      <Route path="kids" element={<Kids />} />
      <Route path="movies" element={<Movies />}></Route>
      <Route path="detail" element={<DetailsFile />} />
      <Route path="tv-show" element={<TvShow />} />
    </Route>

  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
